import {Injectable} from "@angular/core";
import {HttpClient, HttpParams, HttpResponse} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class ApiService {

  localCache: { [key: string]: any[] } = {};
  inFlight: { [key: string]: Promise<any[]> } = {};

  constructor(protected httpClient: HttpClient) {
  }

  get(url: string) {
    return this.notConcurrent(url, this.getData)();
  }

  async getData(self: ApiService, url: string) {

    if (self.localCache[url]) {
      return self.localCache[url];
    }

    let params: HttpParams = new HttpParams();
    let request = self.httpClient
      .get(url, {params: params, headers: {'Content-Type': 'application/json'}})
      .pipe(map((response: HttpResponse<string>) => JSON.parse(response.body)));

    return await request
      .toPromise()
      .then((result: any[]) => {

        self.localCache[url] = result;

        return result;
      });
  }

  notConcurrent(url, proc: (self: ApiService, url: string) => PromiseLike<any[]>) {
    let self = this;
    return () => {
      if (!self.inFlight[url]) {
        self.inFlight[url] = (async () => {
          try {
            return await proc(self, url);
          } finally {
            self.inFlight[url] = null;
          }
        })();
      }
      return self.inFlight[url];
    };
  };
}
